import * as React from 'react';
import styled from 'styled-components';
import { colorsV2 } from '../../../colors-v2';
import { InputCaptionComponentReadOnly } from '../BlogEditor/MediaLogic/component/InputCaptionComponentReadOnly';
import { useFileUploadStore } from '../BlogEditor/model/file-upload-model';
import { observer } from 'mobx-react-lite';
import { s3ToCDN } from '@doltech/utils/lib/url';
import { getEmptyParagraphNode } from '@doltech/utils/lib/editor';
import { getSlateNodeAsTextString } from '@doltech/utils/lib/slateUtils';

const ImagePreview = styled.figure`
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  grid-auto-rows: max-content;
  padding: 0;
  background: transparent;
  border: none;

  .input-caption-wrapper .dol-editor {
    font-size: 16px;
    color: ${colorsV2.black70};
  }

  > img {
    object-fit: contain;
    object-position: center;
    max-width: 100%;
    height: auto;
    border-radius: 8px;
    margin: 0 auto;
  }
`;

const UploadImageNodePreviewBase = ({ element, id }) => {
  const fileUploadStore = useFileUploadStore();
  const fileUploaded = fileUploadStore?.getFileById(id) || element.fileInfo;
  const imageCaption = React.useMemo(() => {
    if (fileUploaded) {
      const { caption } = fileUploaded;
      let result;
      try {
        result = caption
          ? JSON.parse(caption)
          : JSON.parse(fileUploadStore?.getFileById(id)?.caption);
      } catch (ex) {
        result = [getEmptyParagraphNode(caption)];
      }

      try {
        return getSlateNodeAsTextString(result);
        // eslint-disable-next-line no-empty
      } catch (ex) {
      }
      return null;
    }
  }, [fileUploadStore, fileUploaded, id]);

  const imageCaptionText = React.useMemo(() => {
    return imageCaption || fileUploaded?.alt || '';
  }, [fileUploaded?.alt, imageCaption]);

  return (
    <ImagePreview aria-describedby={`caption-attachment-${id}`}>
      {fileUploaded && (
        <img
          width={fileUploaded?.width}
          height={fileUploaded?.height}
          src={fileUploaded?.path ? s3ToCDN(fileUploaded?.path) : fileUploaded?.url}
          alt={fileUploaded?.alt}
          title={fileUploaded?.title}
          loading="lazy"
        />
      )}
      {imageCaptionText && <InputCaptionComponentReadOnly caption={imageCaptionText}/>}
    </ImagePreview>
  );
};

export const UploadImageNodePreview = observer(UploadImageNodePreviewBase);

export const UploadImageNodePreviewV2 = ({ element, id }) => {
  const fileUploaded = element.fileInfo;

  return (
    <ImagePreview>
      <img
        width={fileUploaded?.width}
        height={fileUploaded?.height}
        src={fileUploaded?.path ? s3ToCDN(fileUploaded?.path) : fileUploaded?.url}
        alt={fileUploaded?.alt}
        loading="lazy"
      />
      {fileUploaded?.caption && <InputCaptionComponentReadOnly caption={fileUploaded?.caption}/>}
    </ImagePreview>
  );
};
